import { gql } from '@apollo/client';

const CHECK_DEVICE_CONNECTION_QUERY = gql`
  query checkDeviceConnection($input: LiveEcgInput!) {
    checkDeviceConnection(input: $input) {
      isSuccess
      message
    }
  }
`;

export default CHECK_DEVICE_CONNECTION_QUERY;
